import { Component, OnDestroy } from '@angular/core';
import {
  GetStavkeForZavisneTroskoveQuery,
  UlazneFaktureClient,
  ZavisniTrosakStavkaDto,
  IZavisniTrosakUfResponse
} from '@kodit/core/data-api';
import { Subscription } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { RacunService } from '@kodit/core/services';

@Component({
  selector: 'kodit-zavisni-troskovi-dialog',
  templateUrl: './zavisni-troskovi-dialog.component.html',
  styleUrls: ['./zavisni-troskovi-dialog.component.scss'],
})
export class ZavisniTroskoviDialogComponent implements OnDestroy {
  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Props */
  ufSuggestions: IZavisniTrosakUfResponse[] = [];
  stavke: ZavisniTrosakStavkaDto[] = [];
  selectedStavke: ZavisniTrosakStavkaDto[] = [];

  constructor(
    private _client: UlazneFaktureClient,
    private _dialogConfig: DynamicDialogConfig,
    private _dialogRef: DynamicDialogRef,
    private _racunService: RacunService
  ) {}

  handleSearch(event: any) {
    this._subs.add(
      this._client
        .getRacuneForZavisneTroskove(this._dialogConfig.data.sefId, event.query)
        .subscribe((result) => {
          this.ufSuggestions = [...result.data];
        })
    );
  }

  selectionChanged(value: IZavisniTrosakUfResponse) {
    this._subs.add(
      this._client
        .getStavkeForZavisneTroskove({
          racunId: value.racunId,
        } as GetStavkeForZavisneTroskoveQuery)
        .subscribe((res) => {
          this.stavke = res.data;
        })
    );
  }

  onClose() {
    this._dialogRef.close();
  }

  onSubmit() {
    this._racunService.addZavisneTroskoveFromUf(this.selectedStavke);
    this.onClose();
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
